module.exports = __webpack_public_path__ + "static/img/Ethan_Zuckerman.b674d20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/LandingPage/keynotes/avatar/Ethan_Zuckerman.jpg
// module id = 610
// module chunks = 1